import { SvgIcon, SvgIconProps } from '@mui/material';

// black chevron with no background
const SquareChevronDownIcon = (props: SvgIconProps) => {
  const uniqueId = new Date().getTime();
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      sx={{ width: 24, height: 24, fill: 'none', ...props.sx }}
      data-testid="squareChevronDownIcon"
    >
      <path
        d="M2 6C2 3.79086 3.79086 2 6 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6Z"
        fill="#0B1421"
        fillOpacity="0.1"
      />
      <g clipPath={`url(#clip0_13820_74840-${uniqueId})`}>
        <path
          d="M12 13.2826L8.28445 9.55157C7.87404 9.13945 7.20864 9.13945 6.79823 9.55157C6.38783 9.96369 6.38783 10.6319 6.79823 11.044L11.133 15.3969C11.6118 15.8777 12.3882 15.8777 12.867 15.3969L17.2018 11.044C17.6122 10.6319 17.6122 9.96369 17.2018 9.55157C16.7914 9.13945 16.126 9.13945 15.7155 9.55157L12 13.2826Z"
          fill="#0B1421"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.2137 15.7452C12.5434 16.4183 11.4566 16.4183 10.7863 15.7451L6.45145 11.3922C5.84952 10.7878 5.84952 9.80778 6.45145 9.20334C7.05338 8.59889 8.0293 8.59889 8.63124 9.20334L12 12.5862L15.3688 9.20334C15.9707 8.59889 16.9466 8.59889 17.5486 9.20334C18.1505 9.80778 18.1505 10.7878 17.5486 11.3922L13.2137 15.7452ZM11.4798 15.0487C11.7671 15.3372 12.2329 15.3372 12.5202 15.0487L16.855 10.6958C17.0739 10.476 17.0739 10.1196 16.855 9.8998C16.6361 9.68001 16.2812 9.68001 16.0623 9.8998L12 13.9791L7.93767 9.8998C7.71878 9.68 7.3639 9.68 7.14502 9.8998C6.92613 10.1196 6.92613 10.476 7.14502 10.6958L11.4798 15.0487Z"
          fill="#0B1421"
        />
      </g>
      <defs>
        <clipPath id={`clip0_13820_74840-${uniqueId}`}>
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default SquareChevronDownIcon;
